import React from "react";
import { Button, Icon } from "../../../design-system";

export function PendingRequestsBanner({ requests, isManager, onFulfill, onCancel }) {
  const pending = (requests || []).filter((r) => r.status === "pending");
  if (pending.length === 0) return null;

  return (
    <div
      style={{
        background: "var(--kr-status-warning-bg)",
        border: "1px solid var(--kr-warning-500)",
        borderRadius: 8,
        padding: 14,
        marginBottom: 16,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Icon name="Inbox" size={16} style={{ color: "var(--kr-warning-700)" }} />
        <span style={{ fontSize: 13, fontWeight: 600, color: "var(--kr-status-warning-fg)" }}>
          {isManager
            ? `${pending.length} solicitud${pending.length === 1 ? "" : "es"} pendiente${pending.length === 1 ? "" : "s"}`
            : `Te han pedido ${pending.length} documento${pending.length === 1 ? "" : "s"}`}
        </span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 10 }}>
        {pending.map((req) => (
          <PendingRequestCard
            key={req.id}
            req={req}
            isManager={isManager}
            onFulfill={() => onFulfill?.(req)}
            onCancel={() => onCancel?.(req)}
          />
        ))}
      </div>
    </div>
  );
}

function PendingRequestCard({ req, isManager, onFulfill, onCancel }) {
  const subtitle = req.category?.parent_name
    ? `${req.category.parent_name} › ${req.category.name}`
    : req.category?.name;
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 8,
        padding: 12,
        display: "flex",
        flexDirection: "column",
        gap: 8,
      }}
    >
      <div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--kr-fg-strong)" }}>
          {req.title}
        </div>
        <div style={{ fontSize: 11, color: "var(--kr-fg-muted)", marginTop: 2 }}>
          {subtitle}
          {isManager && req.employee_name ? ` · ${req.employee_name}` : ""}
        </div>
      </div>
      {req.message && (
        <div style={{ fontSize: 12, color: "var(--kr-fg-strong)", lineHeight: 1.4 }}>
          {req.message}
        </div>
      )}
      <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
        {!isManager && (
          <Button variant="primary" size="sm" icon="Upload" onClick={onFulfill}>
            Subir documento
          </Button>
        )}
        {isManager && (
          <Button variant="dangerSoft" size="sm" icon="X" onClick={onCancel}>
            Cancelar
          </Button>
        )}
      </div>
    </div>
  );
}
